import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

const noop = () => {};
const FIX_IFRAME_HEIGHT_INTERVAL = 200;  // in ms

const Frame = createReactClass({
  propTypes: {
    kitToken: PropTypes.string,
    children: PropTypes.element,
    style: PropTypes.object,
    initialContent: PropTypes.string,
    mountTarget: PropTypes.string,
    contentDidMount: PropTypes.func,
    contentDidUpdate: PropTypes.func,
  },

  getDefaultProps() {
    return {
      initialContent: '<!DOCTYPE html><html><head></head><body><div></div></body></html>',
      contentDidMount: noop,
      contentDidUpdate: noop,
    };
  },

  componentDidMount() {
    this._isMounted = true;
    this.renderFrameContents();
  },

  componentDidUpdate() {
    this.renderFrameContents();
  },

  componentWillUnmount() {
    this._isMounted = false;

    const doc = ReactDOM.findDOMNode(this).contentDocument;

    if (doc) {
      ReactDOM.unmountComponentAtNode(doc.body);
    }
  },

  getEmbedCodeScriptNode() {
    const element = ReactDOM.findDOMNode(this).contentDocument.createElement('script');

    element.setAttribute('src', `https://${FORT_AWESOME_USE_URL}/${this.props.kitToken}.js`); // eslint-disable-line no-undef

    return element;
  },

  resizeIFrame() {
    if (!this._isMounted) {
      return;
    }

    const iframeElement = ReactDOM.findDOMNode(this);
    const contentDocument = iframeElement.contentDocument;
    const correctHeight = contentDocument.querySelector('body > div').scrollHeight;

    if (iframeElement.height !== correctHeight) {
      iframeElement.height = correctHeight;
    }

    this._resizeIFrameTimer = setTimeout(this.resizeIFrame, FIX_IFRAME_HEIGHT_INTERVAL);
  },

  renderFrameContents() {
    if (!this._isMounted) {
      return;
    }

    const doc = ReactDOM.findDOMNode(this).contentDocument;

    if (doc && doc.readyState === 'complete') {
      const initialRender = !this._setInitialContent;
      const contents = React.createElement('div',
        undefined,
        this.props.children,
      );

      if (!this._setInitialContent) {
        doc.open();
        doc.write(this.props.initialContent);
        doc.close();

        doc.body.classList.add('iframe-body');
        doc.body.classList.add('v-kit-doc-partial');
        doc.head.appendChild(document.head.querySelector('link[data-style="main"]').cloneNode());
        doc.head.appendChild(this.getEmbedCodeScriptNode());

        this._setInitialContent = true;
      }

      const callback = initialRender ? this.props.contentDidMount : this.props.contentDidUpdate;
      let mountTarget;

      if (this.props.mountTarget) {
        mountTarget = doc.querySelector(this.props.mountTarget);
      } else {
        mountTarget = doc.body.children[0];
      }

      ReactDOM.unstable_renderSubtreeIntoContainer(this, contents, mountTarget, callback);

      this.resizeIFrame();
    } else {
      setTimeout(this.renderFrameContents, 0);
    }
  },

  render() {
    const props = Object.assign({}, this.props);

    delete props.initialContent;
    delete props.contentDidMount;
    delete props.contentDidUpdate;
    delete props.kitToken;

    return React.createElement(
			'iframe',
      Object.assign({style: {border: 'none', width: '100%'}, scrolling: 'no'}, props, {children: undefined})
    );
  },
});

export default Frame;



// WEBPACK FOOTER //
// ./app/javascript/components/KitFrame.js